module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/users-bd1342f2e9756aaed247d9d9fe8914b3.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/users.svg
// module id = 39/X
// module chunks = 24